import { useEffect, useRef, useState } from "react";
import { signalRHub } from "../Utils/common";
import { useNavigate } from "react-router-dom";
import ReactCanvasModal from "./CanvasModel";
import NotificationLogs from "./NotificationLogs";
import { CustomGetAPI } from "../Utils/APIConnector";

function NotificationIcon() {
  const [logs, setLogs] = useState(0);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const userId = window.localStorage.getItem("userid");
  const [notificationData, setNotificationData] = useState([]);
  const connectionRef = useRef(null);
  const navigate = useNavigate();
  useEffect(async () => {
    if (!connectionRef.current && userId) {
      const signalReq = await signalRHub(`User-${userId}`);
      signalReq.on("NotificationUpdated", (message) => {
        setLogs(message?.count);
        if (show) {
          getUsersNotification(true);
        }
      });
      connectionRef.current = signalReq;
    }
  }, [userId]);

  useEffect(() => {
    getUsersNotification(show);
  }, [show]);

  const getUsersNotification = async (flag = false) => {
    try {
      setIsLoading(true);
      await CustomGetAPI(
        `/user/GetAllNotification/${userId}?isReset=${flag}`
      ).then((result) => {
        result = JSON.parse(result);
        if (result?.status == "success") {
          setNotificationData(result?.data);
          setLogs(result?.data?.filter((item) => !item?.isRead)?.length);
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNotificationCLick = () => {
    !userId && navigate("/welcome");
    userId && setShow(true);
  };
  return (
    <>
      <span
        className="cursor-pointer"
        onClick={() => {
          handleNotificationCLick();
        }}
      >
        <img
          src={`/images/${
            logs > 0 ? "NotificationBellDot" : "NotificationBell"
          }.svg`}
          alt=""
        />
      </span>
      <ReactCanvasModal
        show={show}
        setShow={setShow}
        title={"Notifications"}
        htmlBody={
          <NotificationLogs
            isLoading={isLoading}
            notificationData={notificationData}
            setShow={setShow}
          />
        }
        placement="end"
        className={window.innerWidth > 900 && "w-25"}
      />
    </>
  );
}

export default NotificationIcon;
